<template>
  <div id="song">
    <h1>{{data.name}}</h1>
    <span class="lyric">{{data.lyric}}</span>
    <div>
      <button class="round" v-show="previousSongId" @click="goTo(previousSongId)">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" d="M11 17l-5-5m0 0l5-5m-5 5h12" />
        </svg>
      </button>
      <button class="round" v-show="nextSongId" @click="goTo(nextSongId)">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
        </svg>
      </button>
    </div>
  </div>
</template>

<style scoped>
#song { @apply pb-6;}
h1 { @apply text-6xl font-bold mb-8 mt-4;}
span { white-space: pre-line; }
.lyric { @apply text-3xl leading-10;}
button.round { @apply rounded-full bg-white m-4;}
@media (max-width: 425px) {
  h1 { @apply text-3xl font-semibold mb-6;}
  .lyric { @apply text-xl leading-8;}
}
</style>

<script>
import { getCurrentInstance } from '@vue/composition-api';
import useAirtable from '@/stores/airtable';

export default {
  name: 'Song',
  setup() {
    const vm = getCurrentInstance();
    const db = useAirtable();
    if (!db.lyrics) { db.loadLyrics(); }
    const goTo = (songId) => {
      if (songId) {
        vm.proxy.$router.replace({ name: 'Song', params: { id: songId } });
      }
    };
    return {
      db, goTo,
    };
  },
  computed: {
    data() {
      const { id } = this.$route.params;
      if (!this.db.lyrics) { return {}; }
      return this.db.lyrics[id];
    },
    songIndex() {
      const { id } = this.$route.params;
      if (!this.db.songsList || !this.db.songsList.includes(id)) { return undefined; }
      return this.db.songsList.findIndex((e) => e === id);
    },
    nextSongId() {
      if (!this.db.songsList || this.songIndex === undefined) { return undefined; }
      if (this.db.songsList.length - 1 === this.songIndex) { return null; }
      return this.db.songsList[this.songIndex + 1];
    },
    previousSongId() {
      if (!this.db.songsList || this.songIndex === undefined) { return undefined; }
      if (this.songIndex === 0) { return null; }
      return this.db.songsList[this.songIndex - 1];
    },
  },
};
</script>
